/**
 * Возвращает `true`, если браузер не подключен к интеренту
 * Используется в тестах Cypress, для эмуляции offline мода
 */
export function isNetworkOffline() {
    return typeof window !== 'undefined' && !window.navigator.onLine;
}
